import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-ivory-100" data-id="element-278" data-mp="305bsb0t3kmg5">
      <Header data-id="element-279" data-mp="353n1rafhcuxu" />
      <main className="flex-1" data-id="element-280" data-mp="3546b42r2eb09">{children}</main>
      <Footer data-id="element-281" data-mp="355he40coreqb" />
    </div>;
}